import React, { useState } from 'react';
import useUserStore from '../../stores/useUserStore';
import './FrictionModal.css';
import { AlertTriangle, Send, X } from 'lucide-react';

export default function FrictionModal({ isOpen, onClose }) {
    const [feedback, setFeedback] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    
    // User info for attribution
    const user = useUserStore(s => s.user);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!feedback.trim()) return;

        setIsSubmitting(true);

        try {
            if (window.posthog) {
                // Send intent back to posthog
                window.posthog.capture('user_friction_report', {
                    feedback: feedback.trim(),
                    page: window.location.pathname,
                    email: user?.email || 'anonymous',
                });
            }

            setIsSubmitted(true);
            setTimeout(() => {
                onClose();
                // reset state after closing
                setTimeout(() => {
                    setFeedback('');
                    setIsSubmitted(false);
                    setIsSubmitting(false);
                }, 300);
            }, 2000);
            
        } catch (error) {
            console.error("Failed to submit feedback:", error);
            setIsSubmitting(false);
        }
    };

    return (
        <div className="friction-modal-overlay" onMouseDown={onClose}>
            <div className="friction-modal" onMouseDown={e => e.stopPropagation()}>
                <button className="btn btn-ghost btn-icon friction-modal__close" onClick={onClose}>
                    <X size={20} />
                </button>
                
                {isSubmitted ? (
                    <div className="friction-modal__success">
                        <h3>Thanks for letting us know!</h3>
                        <p>Your feedback has been sent directly to the team.</p>
                    </div>
                ) : (
                    <>
                        <div className="friction-modal__header">
                            <div className="friction-modal__icon">
                                <AlertTriangle size={24} />
                            </div>
                            <h3>Did something go wrong?</h3>
                            <p>We noticed you might be stuck. Tell us what you were trying to do so we can fix it.</p>
                        </div>

                        <form onSubmit={handleSubmit} className="friction-modal__form">
                            <textarea
                                className="friction-modal__textarea ph-no-capture"
                                placeholder="I was trying to..."
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                autoFocus
                                disabled={isSubmitting}
                            />
                            
                            <div className="friction-modal__actions">
                                <button 
                                    type="button" 
                                    className="btn btn-tertiary btn-lg friction-modal__btn-secondary"
                                    onClick={onClose}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="submit" 
                                    className="btn btn-primary btn-lg btn-icon friction-modal__btn-primary"
                                    disabled={!feedback.trim() || isSubmitting}
                                >
                                    {isSubmitting ? 'Sending...' : 'Send Feedback'}
                                    <Send size={16} />
                                </button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
